import { usePageEvent, useTrackEvent } from "@/libs/analytics/useAnalytics";
import {
  create3DFileDownloadViewedPageEventPayload,
  createDownloadReadyTrackEventPayload,
  createPrepareDownloadClickedTrackEventPayload,
} from "nvs-analytics";

//3D File Download Analytics

export const use3DFileDownloadViewedAnalytics = () => {
  return usePageEvent(create3DFileDownloadViewedPageEventPayload);
};

export const usePrepareDownloadClickedAnalytics = () => {
  return useTrackEvent(createPrepareDownloadClickedTrackEventPayload);
};

export const useDownloadReadyAnalytics = () => {
  return useTrackEvent(createDownloadReadyTrackEventPayload);
};
